"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAverageUploadSpeed = void 0;
function calculateAverageUploadSpeed() {
    var chunksUploadSpeeds = [];
    return function (startTimeChunkUpload, endTimeChunkUpload, chunkSize) {
        // Calculate the data-transfer speed | bytes per second
        var bytesPerSecondUploadedChunk = (chunkSize / (endTimeChunkUpload - startTimeChunkUpload)) * 1000;
        if (chunksUploadSpeeds.length >= 6) {
            chunksUploadSpeeds.pop();
            chunksUploadSpeeds.unshift(bytesPerSecondUploadedChunk);
        }
        else {
            chunksUploadSpeeds.push(bytesPerSecondUploadedChunk);
        }
        var averageUploadSpeed = chunksUploadSpeeds.reduce(function (totalBytesSizeUploadedChunks, byteSizeOfLastUploadedChunk) {
            return totalBytesSizeUploadedChunks + byteSizeOfLastUploadedChunk;
        }, 0) / chunksUploadSpeeds.length;
        return averageUploadSpeed;
    };
}
exports.calculateAverageUploadSpeed = calculateAverageUploadSpeed;
//# sourceMappingURL=calculateAverageUploadSpeed.js.map